import styled from 'styled-components'

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
  padding: 24px;
  gap: 1rem;
`

export const ErrorSection = styled.div<{ $bottomSheetMode?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 8px;

  ${({ $bottomSheetMode }) => ($bottomSheetMode ? `margin-bottom: 50px;` : `margin: 50% 0px;`)}
  text-align: center;

  svg {
    margin-bottom: 20px;
  }
`
export const FooterErrorSection = styled.div`
  position: fixed;
  bottom: 24px;
  width: calc(100% - 48px);
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Wrapper = styled.div``

export const SkeletonContainer = styled.div`
  display: flex;
  width: 100%;
  border-radius: 8px;
  background: var(--gray100);
  padding: 20px;
  margin: 8px 0px;
`
